

  
  
import {
  GETMONTLYGSTDETAILS,
  GETMONTLYGSTDETAILSREPORT,
} from "../../../utils/api";
import axios from "../../../utils/axios";

// }
export const getMonthlyDetails = async (param) => {
  const res = await axios.post(GETMONTLYGSTDETAILS, param);
  return res;
};
export const getMonthlyDetailsReport = async (param, blob) => {
  const res = await axios.post(GETMONTLYGSTDETAILSREPORT, param, blob);
  return res;
};